const dateFormatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });

/** "23 oct. 2026"; a date that is not known shows "—". */
const formatShortDate = (date: Date | null): string => {
	return date === null ? '—' : dateFormatter.format(date);
};

export default formatShortDate;
